// IntelligenceTrace — the "why did ARIA surface this?" causal chain.
// Renders a compact horizontal source → signal → action trace so a
// recommendation is never a black box. Pure presentational.
import React from 'react';

export default function IntelligenceTrace({ nodes }) {
  if (!nodes || nodes.length === 0) return null;
  return (
    <div className="hm-trace" aria-label="Why ARIA surfaced this">
      {nodes.map((node, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <span className="hm-trace-arrow" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="4" y1="12" x2="20" y2="12" />
                <polyline points="14 6 20 12 14 18" />
              </svg>
            </span>
          )}
          <span className={`hm-trace-node hm-trace-${node.type || 'signal'}`}>
            {node.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
